module.exports = __webpack_public_path__ + "img/GIUpdates-Logo@0.75x.dea6cabb.png";